import Nullstack from 'nullstack';
export default function IconReceiptTax({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-receipt-tax",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "9",
    y1: "14",
    x2: "15",
    y2: "8"
  }), "   ", Nullstack.element("circle", {
    cx: "9.5",
    cy: "8.5",
    r: ".5",
    fill: "currentColor"
  }), "   ", Nullstack.element("circle", {
    cx: "14.5",
    cy: "13.5",
    r: ".5",
    fill: "currentColor"
  }), "   ", Nullstack.element("path", {
    d: "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2"
  }), " ");
}